class StopLookupModel extends App.Models.Stop { }

App.Models.StopLookup = StopLookupModel;
